(() => {
  function toggle() {
    const elems = window.swinger.$('.swinger-components-browser__component');

    if (!elems.length) {
      return;
    }

    elems.forEach((elem) => {
      elem.classList.remove('swinger-components-browser__component--is-current');
    });

    if (!window.location.hash) {
      return;
    }

    const link = window.swinger.$(`a[href="${window.location.hash}"]`, document)[0];
    const target = window.swinger.$(window.location.hash, document)[0];

    if (link) {
      link.focus();
    }
    target.classList.add('swinger-components-browser__component--is-current');
  }

  window.swinger.eventHub.register('click', '.swinger-components-browser__navigation a[href^="#"]', (e) => {
    const hash = window.swinger.eventHub.getTarget(e).getAttribute('href');

    if (hash === window.location.hash) {
      if (window.history) {
        window.history.replaceState('', document.title, window.location.pathname);
        toggle();
      } else {
        window.location.hash = '#index';
      }

      e.preventDefault();
      window.swinger.$('.swinger-components-browser__intro', document)[0].focus();
      return;
    }

    window.location.hash = hash;
    e.preventDefault();
    e.target.focus();
  });

  window.addEventListener('hashchange', toggle);

  // toggle();

  window.swinger.eventHub.register('click', '.swinger-components-browser__content a[href^="#"]', (e) => {
    e.stopImmediatePropagation();
  });

  window.addEventListener('DOMContentLoaded', () => {
    const navigation = window.swinger.$('.swinger-components-browser .swinger-navigation', document)[0];

    if (navigation) {
      navigation.removeAttribute('aria-hidden');
    }
  });
})();
